<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button type="primary" v-if="backRole('ST_4')" @click="EditStorageRoom('create')" size="mini">添加仓库
        </el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <!-- <el-table-column prop="deptName" label="所属公司">
      </el-table-column> -->
      <el-table-column label="仓库名">
        <template slot-scope="scope">
          <span class="level-label" v-if="scope.row.level=='2'">子</span>
          {{scope.row.name}}
          <!-- <router-link class="table-link" :to="'/Storage/Detail/' + scope.row.id">
          </router-link> -->
        </template>
      </el-table-column>
      <el-table-column prop="address" label="详细地址">
      </el-table-column>

      <el-table-column label="仓库管理员" width="250px">
        <template slot-scope="scope">
          <div v-html="getUserList(scope.row.managers)"></div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="160px">
        <template slot-scope="scope">
          <!-- <router-link class="table-link" :to="'/Storage/Detail/' + scope.row.id">
            <el-button plain size="mini" type="primary">详情</el-button>
          </router-link> -->
          <el-button plain size="mini" @click="EditStorageRoom(scope.row)">修改</el-button>
          <el-button plain size="mini" @click="DeleteStorageRoom(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加/编辑仓库 -->
    <div class="pop-room" v-if="addStorageRoomStatus">
      <a href="javascript:;" @click="addStorageRoomStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form">
            <el-form-item label="所属公司">
              <el-select :disabled="noSelectOrganization" size="small" class="organization-select" v-model="form.depId"
                placeholder="请选择所属公司">
                <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="仓库名">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="仓库级别">
              <el-radio v-model="form.level" label="1">父级仓库</el-radio>
              <el-radio v-model="form.level" label="2">二级仓库</el-radio>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5}" placeholder="请输入仓库详细地址"
                v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item label="仓库管理员">
              <div class="contact-user-list">
                <div class="user-item" v-for="user,i in selectLeader">
                  <span class="name">{{user.name}}</span>
                  <span @click="deleteUsers(i)" class="iconfont icon-close1"></span>
                </div>
              </div>
              <!-- <div class="user-item" v-if="selectLeader.name" style="margin-right:5px;">
                <span class="name">{{selectLeader.name}}</span>
              </div> -->
              <el-button @click="addUsers()" size="mini" type="primary">选择员工</el-button>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="addStorageRoom()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,

        contactSelectArr: state => state.main.contactSelectArr,
      })
    },
    data() {
      return {
        selectLeader: [],
        type: 1,

        organizationListData: [],
        noSelectOrganization: true,
        form: {
          depId: "",
          name: "",
          address: "",
          managerIds: "",
          // 默认1， 二级仓库2
          level: "1",
        },
        addStorageRoomStatus: false,

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }

      // 获取所有仓库
      this.getLists()
    },
    methods: {
      // 显示管理员
      getUserList(users, type) {
        if (!users) {
          return
        }
        let _item = ""
        // let max = 3
        let _length = users.length
        // if (!type) {
        //   _length = users.length > max ? max : users.length
        // } else {
        //   _length = users.length
        // }

        for (var i = 0; i < _length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },
      // 删除管理员
      deleteUsers(index) {
        this.selectLeader.splice(index, 1)
      },
      // 修改仓库
      EditStorageRoom(row) {
        if (row == 'create') {
          this.type = 1
          this.addStorageRoomStatus = true
          this.form = {
            depId: this.userData.secDepIds.split(",")[0] / 1,
            name: "",
            address: "",
            managerIds: "",
            // 默认1， 二级仓库2
            level: "1",
          }
        } else {
          this.type = 2
          this.addStorageRoomStatus = true
          this.form.depId = row.department.id
          this.form.address = row.address
          this.form.name = row.name
          this.form.level = row.level
          // this.form.userId = row.linkman.id
          this.selectLeader = row.managers
          // this.form.managerIds = row.managers.map(item => item.id).join(",")
          this.form.houseId = row.id
        }
      },
      // 删除仓库
      DeleteStorageRoom(row) {
        // if (row.conferences.length > 0) {
        //   this.$message.error("该仓库已经正常使用，无法删除该仓库")
        // }
        this.$confirm('此操作将永久删除该仓库, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          ajax.post('/storage/house/del', {
            'houseId': row.id
          }, (res) => {
            this.loading = false
            this.$message.success("删除仓库成功")
            this.getLists()
          }, res => {
            this.loading = false
          })
        })
      },
      // 添加/修改仓库
      addStorageRoom() {
        if (!this.form.address) {
          this.$message.error("仓库名/位置不能为空")
          return
        }

        let _form = this.form
        // _form.userId = this.selectLeader.id
        this.form.managerIds = this.selectLeader.map(item => item.id).join(",")

        if (!this.form.managerIds) {
          this.$message.error("仓库管理员不能为空")
          return
        }

        let _url = '/storage/house/add'
        if (this.type == 2) {
          _url = '/storage/house/edit'
        }

        ajax.post(_url, _form, (res) => {
          if (this.type == 2) {
            this.$message.success("修改仓库成功")
          } else {
            this.$message.success("添加仓库成功")
          }
          this.addStorageRoomStatus = false
          this.getLists()
        })
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterName)
        if (this.filterName) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.filterName) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.get('/storage/house/list', {
          'depId': this.form.depId
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
      // 添加仓库管理员
      addUsers(type) {
        this.selectType = type

        let _sr = this.selectLeader
        this.$store.commit('set_contactSelectArr', _sr)

        this.$store.commit('set_contactShow', true)
        this.$store.commit('set_contactSingleSelect', false)
      },
    },
    watch: {
      contactSelectArr() {
        this.selectLeader = this.contactSelectArr
      },
      'form.depId'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/storage/roomList.vue